module.exports = __webpack_public_path__ + "static/18-receipt 1-e12cf9922f384bf5ebe912b840d4576e.svg";